import React from 'react';
import { Link } from 'react-router-dom';
import { Collapse, Spin } from 'antd';
import { CollapseUp, CollapseDown } from '../../assets/icons';
import { Images } from '../../config/images';
import './PropertyFaq.scss';
import { useSelector } from 'react-redux';
import { createMarkup } from '../../utils/createMarkup';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const PropertyFaq = (props) => {
  const { Panel } = Collapse;
  const { data = {}, loading = true } = useSelector((state) => state.faqs);

  return (
    <div className='py-64 property-faq'>
      <p className='mb-32 fz-24 fw-700 lh-13'>Frequently Asked Questions</p>
      <Spin spinning={loading}>
        <Collapse
          accordion
          defaultActiveKey={0}
          expandIconPosition='end'
          expandIcon={({ isActive }) => (isActive ? <CollapseDown width='15' /> : <CollapseUp width='15' />)}
        >
          {data?.data?.faqList?.map((faq, index) => {
            return (
              <Panel header={faq.question} key={faq?.id || index}>
                <div dangerouslySetInnerHTML={createMarkup(faq?.content)}></div>
              </Panel>
            );
          })}
        </Collapse>
      </Spin>
      <p className='fz-18 fw-600 mb-16'>Having trouble deciding on a property?</p>
      <div className='faq-art'>
        <p className='mb-0'>
          Our acquisitions team has already scrutinized and evaluated all proposed Realbricks rental properties that may become part of the Realbricks marketplace. One approach is to consider spreading investments across a variety of accessible homes to potentially create a diverse portfolio rather than focusing on a single property to invest in. For more information,{' '}
          <Link to='/account/help-center' className='fw-600 text-terracotta underline'>
            visit our help center.
          </Link>
        </p>
        <div className='text-right faq-art__image'>
          <LazyLoadImage src={Images.faqArt} alt='' />
        </div>
      </div>
    </div>
  );
};

export default PropertyFaq;
